import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../services/apiClient';

export interface Announcement {
  id: string;
  message: string;
  announcement_type: 'info' | 'warning' | 'error';
  created_at: string;
}

interface AnnouncementsResponse {
  announcements: Announcement[];
}

/**
 * 有効なお知らせ一覧を取得するフック
 * 5分ごとに自動更新、ウィンドウフォーカス時にも再取得
 */
export function useAnnouncements() {
  return useQuery<Announcement[]>({
    queryKey: ['announcements'],
    queryFn: async () => {
      const response = await apiClient.get<AnnouncementsResponse>('/announcements');
      return response.data.announcements;
    },
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
